import type { HowItWorksProps } from '@/components/giveback/HowItWorks';
import type { InternalImpactProps } from '@/components/giveback/InternalImpact';
import type { JoinTheGivebackProps } from '@/components/giveback/JoinTheGiveback';
import type { ImpactSectionProps } from '@/components/giveback/OurCommunityImpact';
import type { OurImpact2024Props } from '@/components/giveback/OurImpact2024';
import type { PublicBenefitProps } from '@/components/giveback/PublicBenefit';
import type { WhatIsGivebackProps } from '@/components/giveback/WhatIsGiveback';
import works_1 from '@/static/assets/giveback_2024/de/desktop-phone.svg';
import works_1_mobile from '@/static/assets/giveback_2024/de/mobile-phone.svg';
import works_2 from '@/static/assets/giveback_2024/de/desktop-coins.svg';
import works_2_mobile from '@/static/assets/giveback_2024/de/mobile-coins.svg';
import type { BasePageConfig } from '../../BasePageConfig';
import { config as usConfig } from '../us/en';
import coinToHeart from '@/static/assets/giveback_2024/de/coin_to_heart.gif';

export interface Config extends BasePageConfig {
  whatIsGiveback: WhatIsGivebackProps;
  howItWorks: HowItWorksProps;
  ourImpact2024: OurImpact2024Props;
  ourCommunityImpact: ImpactSectionProps;
  joinTheGiveback: JoinTheGivebackProps;
  publicBenefit: PublicBenefitProps;
  internalImpact: InternalImpactProps;
}

export const config: Config = {
  ...usConfig,
  howItWorks: {
    ...usConfig.howItWorks,
    steps: [
      {
        text: 'You get a Lemonade policy, and\nselect a cause you care about',
        image: works_1,
        mobileImage: works_1_mobile,
      },
      {
        text: 'Throughout the year, your coverage helps fund real impact',
        image: works_2,
        mobileImage: works_2_mobile,
      },
    ],
  },
  joinTheGiveback: {
    ...usConfig.joinTheGiveback,
    animatedImage: coinToHeart,
  },
};
